<template>
  <div>
    <div v-show="!isLoading" class="content_cell" style="height: 100%;">
      <div>
        <div class="p_title">{{course_name}}</div>
        <div class="p_info">學生人數: {{sortedStudents.length}}</div>
      </div>
      <div style="overflow-x: auto; position: relative; height: 80%;" id="table_container">
        <table id="member_list">
          <thead>
            <tr class="std_title">
              <td>學生</td>
              <td>電郵</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in sortedStudents" :key="student.id" class="std_list">
              <td style="line-height:3.5;" class="std_name">
                <img style="display: none;" class="icon" src="@/assets/image/std_thum.png">{{student.name}}
              </td>
              <td>{{student.email}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<style scoped>
.content_cell {
    -moz-box-shadow: 0 0 5px #8DD;
    -webkit-box-shadow: 0 0 5px #8DD;
    box-shadow: 0 0 5px #8DD;
    background-color: #fff;
    padding: 28px;
    border-radius: 11px;
    font-size: 15pt;
    font-weight: bold;
    color: rgb(142, 202, 147);
}
.std_title {
    background-color:rgb(122, 189, 122);
    color:white;
    text-align:center;
}
.std_list {
    font-size:11pt;
    font-weight:lighter;
    color:rgb(158, 160, 163);
}
.p_title {
    color:rgb(136, 140, 143);
    font-size:16pt;
    line-height: 1.8;
}
.p_info {
    font-size:11pt;
    font-weight:lighter;
}
#member_list {
  width: 100%;
  border:1px solid;
  table-layout: auto;
  min-width: 750px;
}
td, .th{
  padding: 8px;
  font-size: small;
  /*overflow-x: hidden;
  text-overflow: ellipsis;*/
}
tr { border-bottom: 1px solid; }
.stdid{
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.std_name{
  display: flex;
}
.search_gb {
    padding:5px;
}
.icon{
  margin-right: 20px;
  width: 50px;
  height: 50px;
}
body {
    background-color: rgb(243,243,243)!important;
}
@media (min-width: 992px){
  td, th{
    font-size: initial;
    text-align: center;
  }
  .stdid{
  }
  .std_name{
    display: block;
  }
  .desc{
    display: none;
  }
}
.std_list.toggle_lms .dropdown_lms{
    display: block;
}
.std_list>td{
  position: relative;
}
</style>
<script>
import Loading from '@/components/Utility/Loading.vue'
export default {
  data () {
    return {
      isLoading: true,
      course_id: parseInt(this.$route.query.course),
      students: []
    }
  },
  components: {
    Loading
  },
  computed: {
    sortedStudents () {
      return this.students.slice(0).sort((a, b) => a.name < b.name ? -1 : 1)
    },
    course_name () {
      return this.$parent.courseInfo.name
    }
  },
  async created () {
    await this.$store.dispatch('request', {
      route: 'courses/' + this.course_id + '/members'
    }).then(r => {
      console.log(r)
      r.forEach((value) => {
        if (value.role === 'student') {
          console.log(value)
          this.students.push(value)
        }
      })
    })
    this.isLoading = false
  }
}
</script>
